import { define } from '@rlean/core';

const UserRoles = define('userRoles', {
  initialState: { roles: [] },
});

export default UserRoles;
